// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen';
export class OrganizationService {
    /**
     * Get all organizations
     *
     * Returns a list of all organizations (clients, suppliers) based on filters.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations',
            ...options
        });
    }
    /**
     * Create new organization
     *
     * Creates a new organization within the system.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete organization
     *
     * Removes an organization from the system by its UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations/{uuid}',
            ...options
        });
    }
    /**
     * Get organization detail
     *
     * Returns details of a specific organization by its UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations/{uuid}',
            ...options
        });
    }
    /**
     * Update organization
     *
     * Updates organization data by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish organizations to PubSub
     *
     * Publishes the current state of organizations to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/organizations/create-updated-messages',
            ...options
        });
    }
}
export class DepartmentService {
    /**
     * Get departments list
     *
     * Returns a list of all departments within the organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/departments',
            ...options
        });
    }
}
export class CollaboratorsService {
    /**
     * Get all collaborators
     *
     * Returns a list of all collaborators based on filters and user permissions.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators',
            ...options
        });
    }
    /**
     * Create collaborator
     *
     * Creates a new collaborator in the system with data validation and permission checks.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get collaborator warnings
     *
     * Returns a list of collaborators who have some warnings (e.g., missing data).
     */
    static getAllWarnings(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/warnings',
            ...options
        });
    }
    /**
     * Get managed organizations
     *
     * Returns a list of organizations managed within the collaborators module.
     */
    static getOrganizationsForCollaborators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/organizations',
            ...options
        });
    }
    /**
     * Get supplier organizations
     *
     * Returns a list of organizations marked as suppliers.
     */
    static getSupplierOrganizations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/supplier-organizations',
            ...options
        });
    }
    /**
     * Get collaborator names and IDs
     *
     * Returns a shortened list of collaborators containing only names and IDs for selection purposes.
     */
    static getNameIds(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/name-id',
            ...options
        });
    }
    /**
     * Publish collaborators to PubSub
     *
     * Publishes messages about collaborator creation or updates to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/create-updated-messages',
            ...options
        });
    }
    /**
     * Delete collaborator
     *
     * Removes a collaborator from the system by their UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}',
            ...options
        });
    }
    /**
     * Get collaborator detail
     *
     * Returns details of a specific collaborator by their UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}',
            ...options
        });
    }
    /**
     * Update collaborator
     *
     * Updates collaborator data by their UUID with data validation and permission checks.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorPositionsService {
    /**
     * Get all collaborator positions
     *
     * Returns a list of all collaborator positions within the organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-positions',
            ...options
        });
    }
    /**
     * Get all collaborator positions for all companies
     *
     * Returns a complete list of positions across all companies in the system.
     */
    static getAllForAllCompanies(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-positions-all-companies',
            ...options
        });
    }
    /**
     * Get collaborator positions by permissions
     *
     * Returns a list of positions that the current user can access based on their permissions.
     */
    static getAllPositionsWithPermissions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-positions-permissions',
            ...options
        });
    }
}
export class CollaboratorSkillService {
    /**
     * Get all skills
     *
     * Returns a list of all defined skills for the organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-skills',
            ...options
        });
    }
    /**
     * Create new skill
     *
     * Adds a new skill to the list of available skills.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-skills',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete skill
     *
     * Removes a skill from the list of available skills by UUID.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-skills/{uuid}',
            ...options
        });
    }
    /**
     * Update skill
     *
     * Updates the name or description of an existing skill by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-skills/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorSkillsHeatmapService {
    /**
     * Get collaborator skills heatmap
     *
     * Returns a matrix of collaborators and their skill levels for heatmap visualization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-skills-heatmap',
            ...options
        });
    }
}
export class CollaboratorSkillValuesService {
    /**
     * Get collaborator skill values
     *
     * Returns a list of all skills and their values for a specific collaborator.
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/collaborator-skill-values',
            ...options
        });
    }
    /**
     * Update collaborator skill values
     *
     * Bulk updates or creates skill values for a specific collaborator.
     */
    static update(options) {
        return (options.client ?? client).put({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/collaborator-skill-values',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Mark collaborator skill values as up-to-date
     *
     * Updates the flag indicating that a collaborator's skills have been reviewed and are currently up-to-date.
     */
    static markCollaboratorSkillValuesUpToDate(options) {
        return (options.client ?? client).patch({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/mark-collaborator-skill-values-up-to-date',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorLeavingChecklistItemService {
    /**
     * Get collaborator leaving checklist
     *
     * Returns the status of all leaving checklist items for a specific collaborator by UUID.
     */
    static getLeavingChecklist(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/leaving-checklist-items/{type}',
            ...options
        });
    }
    /**
     * Initialize collaborator leaving checklist
     *
     * Creates a default leaving checklist for a collaborator by UUID based on the global items list.
     */
    static initLeavingChecklist(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/leaving-checklist-items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Save collaborator leaving checklist status
     *
     * Updates the fulfillment status of individual leaving checklist items for a collaborator by UUID.
     */
    static saveLeavingChecklist(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborators/{uuid}/leaving-checklist-items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class LeavingChecklistItemService {
    /**
     * Get leaving checklist items
     *
     * Returns a list of all items to be checked when a collaborator leaves.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/leaving-checklist-items',
            ...options
        });
    }
    /**
     * Create new leaving checklist item
     *
     * Adds a new item to the global list of leaving checklist items.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/leaving-checklist-items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete leaving checklist item
     *
     * Removes an item from the global list of leaving checklist items by UUID.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/leaving-checklist-items/{uuid}',
            ...options
        });
    }
    /**
     * Update leaving checklist item
     *
     * Updates the name or other properties of a leaving checklist item by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/leaving-checklist-items/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorWorkPlansService {
    /**
     * Get work plans for a given month
     *
     * Returns a summary of collaborator work plans and total planned costs for a specific month.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-work-plans/{month}',
            ...options
        });
    }
    /**
     * Create new collaborator work plan
     *
     * Creates a work plan for a specific collaborator.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-work-plans',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update collaborator work plan
     *
     * Updates an existing work plan by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-work-plans/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update all collaborator work plans
     *
     * Bulk updates basic work days for all collaborators in a given month.
     */
    static updateAll(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-work-plans-update-all',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorProfilesService {
    /**
     * Get all collaborator profiles
     *
     * Returns a list of collaborator profiles including their basic info, years of experience, team lead status, strengths/weaknesses, technologies, positions, skill values, and certifications.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-profiles',
            ...options
        });
    }
    /**
     * Create collaborator profile
     *
     * Creates a new profile for a collaborator, including experience, team lead preferences, and strengths description.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-profiles',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get collaborator profile detail
     *
     * Returns a detailed collaborator profile including basic info, experience, strengths, technologies, assigned positions, skill values, and certifications by the collaborator UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-profiles/{collaboratorUuid}',
            ...options
        });
    }
    /**
     * Update collaborator profile
     *
     * Updates an existing collaborator profile including experience, team lead preferences, and strengths description by the profile UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-profiles/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorProjectWorkTypesService {
    /**
     * Get project work types for a collaborator
     *
     * Returns a list of all projects and assigned work types for a specific collaborator by UUID.
     */
    static getList(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-work-types/{uuid}',
            ...options
        });
    }
    /**
     * Update project work types for a collaborator
     *
     * Bulk updates or assigns work types to projects for a specific collaborator by UUID.
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-work-types/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorCertificationsService {
    /**
     * Certification types CATALOG (configuration list) — NOT assigned certifications
     *
     * Returns a list of all certifications configuration in the system. For certification assigned to collaborator use collaborator profile endpoint
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types',
            ...options
        });
    }
    /**
     * Create certification types CATALOG item (configuration) — NOT assigned certifications
     *
     * Creates a new certification configuration in the system. For certification assigned to collaborator use collaborator profile endpoint
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete certification types CATALOG item (configuration) — NOT assigned certifications
     *
     * Removes a certification configuration from the system by its UUID. For certification assigned to collaborator use collaborator profile endpoint
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types/{uuid}',
            ...options
        });
    }
    /**
     * Certification types CATALOG detail (configuration) — NOT assigned certifications
     *
     * Returns the detail of a specific certification configuration by its UUID. For certification assigned to collaborator use collaborator profile endpoint
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types/{uuid}',
            ...options
        });
    }
    /**
     * Update certification types CATALOG item (configuration) — NOT assigned certifications
     *
     * Updates certification configuration data by its UUID. For certification assigned to collaborator use collaborator profile endpoint
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish certification types CATALOG state to PubSub (admin/config)
     *
     * Publishes the current state of certifications to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/certification-types/create-updated-messages',
            ...options
        });
    }
}
export class StatisticsService {
    /**
     * Get collaborator statistics
     *
     * Returns collaborator statistics (internal or external) for a given year, including breakdown by department and position.
     */
    static getCollaboratorStatistics(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator/statistics',
            ...options
        });
    }
}
export class CollaboratorProfitService {
    /**
     * Get collaborator profit for a month
     *
     * Returns aggregated worked hours, billed hours, costs, revenues and margin per collaborator for a given month across all projects.
     */
    static getCollaboratorProfit(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-profit',
            ...options
        });
    }
}
export class CollaboratorCapacityReportService {
    /**
     * Get collaborator capacity report
     *
     * Returns a detailed overview of collaborator capacities and utilization for specified months.
     */
    static getCollaboratorCapacityReport(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-capacity-report',
            ...options
        });
    }
}
export class ProjectCollaboratorPlansService {
    /**
     * Get project plans for collaborators
     *
     * Returns a list of all plans for individual collaborators on projects in a given period.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-collaborator-plans',
            ...options
        });
    }
    /**
     * Get collaborator project plan capacities
     *
     * Returns an overview of collaborator capacity utilization across projects for a given period.
     */
    static getProjectCollaboratorPlanCapacity(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-collaborator-plans/capacity',
            ...options
        });
    }
    /**
     * Save collaborator project plans
     *
     * Bulk saves or updates collaborator plans on projects for a specific date with an option to send notifications.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-collaborator-plans/{date}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectPlanService {
    /**
     * Get project plans
     *
     * Returns a list of all project plans for a given time period and organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-plans',
            ...options
        });
    }
    /**
     * Save project plans
     *
     * Bulk saves or updates project plans for a specific date.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-plans/{date}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectPlanConfigService {
    /**
     * Get project planning configuration
     *
     * Returns settings for project planning (e.g., work time fund) for a given month.
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-plan-config/{date}',
            ...options
        });
    }
    /**
     * Update project planning configuration
     *
     * Saves or updates settings for project planning for a specific month.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-plan-config/{date}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectService {
    /**
     * Get all projects
     *
     * Returns a list of projects based on filters and user permissions (own or all).
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects',
            ...options
        });
    }
    /**
     * Create new project
     *
     * Creates a new project within the organization.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get project categories
     *
     * Returns a list of all unique categories (tags) used in projects.
     */
    static getCategories(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/category-list',
            ...options
        });
    }
    /**
     * Get organizations assigned to projects
     *
     * Returns a list of all organizations that figure as clients in projects.
     */
    static getOrganizations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/organization-list',
            ...options
        });
    }
    /**
     * Get sales managers assigned to projects
     *
     * Returns a list of all collaborators who are listed as sales managers in projects.
     */
    static getSalesManagers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/sales-manager-list',
            ...options
        });
    }
    /**
     * Get project coordinators
     *
     * Returns a list of all collaborators who are listed as project coordinators in projects.
     */
    static getProjectCoordinators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/project-coordinator-list',
            ...options
        });
    }
    /**
     * Get project leads
     *
     * Returns a list of all collaborators who are listed as project leads in projects.
     */
    static getProjectLeads(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/project-lead-list',
            ...options
        });
    }
    /**
     * Get dev leads
     *
     * Returns a list of all collaborators who are listed as dev leads in projects.
     */
    static getDevLeads(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/dev-lead-list',
            ...options
        });
    }
    /**
     * Get overview of all project calculations
     *
     * Returns a summary overview of financial calculations for all projects in a given month.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/calculation',
            ...options
        });
    }
    /**
     * Get sales projects statistics
     *
     * Returns financial statistics for sales projects in a given month.
     */
    static getSalesProjectsStatistics(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/sales-project-statistics',
            ...options
        });
    }
    /**
     * Delete project
     *
     * Removes a project from the system by its UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{uuid}',
            ...options
        });
    }
    /**
     * Get project detail
     *
     * Returns details of a specific project by its UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{uuid}',
            ...options
        });
    }
    /**
     * Update project
     *
     * Updates project data by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish projects to PubSub
     *
     * Publishes the current state of projects to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/create-updated-messages',
            ...options
        });
    }
    /**
     * Force ticket project assignment
     *
     * Manually changes or forces the assignment of a ticket to a specific project.
     */
    static putTicketForceProject(options) {
        return (options.client ?? client).put({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/ticket-force-project',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectCalculationService {
    /**
     * Get overview of all project calculations
     *
     * Returns a summary overview of financial calculations for all projects in a given month.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/calculation',
            ...options
        });
    }
    /**
     * Get sales projects statistics
     *
     * Returns financial statistics for sales projects in a given month.
     */
    static getSalesProjectsStatistics(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/sales-project-statistics',
            ...options
        });
    }
    /**
     * Get projects for calculations
     *
     * Returns a list of projects for which calculations can be performed or displayed.
     */
    static getProjects(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/calculation/all-projects',
            ...options
        });
    }
    /**
     * Get project calculation for a given month
     *
     * Returns a detailed financial calculation of a specific project for a given month.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/calculation/{month}',
            ...options
        });
    }
    /**
     * Update project calculation
     *
     * Updates financial calculation parameters of a project for a given month.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/calculation/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Sync FTFP revenues and return the project calculation
     *
     * Materializes fixed-price (FTFP) revenue rows for the project + month from its valid fixed-price orders and returns the refreshed calculation. Called by the client after saving the Collaborator project rates dialog.
     */
    static syncFtfp(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/calculation/{month}/sync-ftfp',
            ...options
        });
    }
    /**
     * Get FTFP monthly allocation state
     *
     * Returns every fixed-price (FTFP) order whose validity covers the month, with the amount allocated to that month, the order total and how much of it is still free to allocate. Backs the FTFP section of the Collaborator rates dialog.
     */
    static getFtfpAllocations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/calculation/{month}/ftfp-allocations',
            ...options
        });
    }
    /**
     * Set FTFP monthly allocations
     *
     * Stores the selected month's amounts (in CZK hundredths) for one or more fixed-price (FTFP) orders and returns the refreshed calculation. Refuses amounts that would push an order above its contract price.
     */
    static setFtfpAllocations(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/calculation/{month}/ftfp-allocations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectTypeService {
    /**
     * Get all project types
     *
     * Returns a list of all available project types for the organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-types',
            ...options
        });
    }
    /**
     * Create new project type
     *
     * Creates a new project category/type in the system.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete project type
     *
     * Removes a project type from the system by its UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-types/{uuid}',
            ...options
        });
    }
    /**
     * Update existing project type
     *
     * Updates the name or properties of a project type by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/project-types/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ContactService {
    /**
     * Get all contacts
     *
     * Returns a list of contact persons for projects based on filters and user permissions.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/contacts',
            ...options
        });
    }
    /**
     * Create new contact
     *
     * Creates a new contact person and assigns them to a project.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/contacts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete contact
     *
     * Removes a contact person from the system by their UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/contacts/{uuid}',
            ...options
        });
    }
    /**
     * Get contact detail
     *
     * Returns details of a specific contact person by their UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/contacts/{uuid}',
            ...options
        });
    }
    /**
     * Update existing contact
     *
     * Updates details of a contact person by their UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/contacts/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CostsPlanningService {
    /**
     * Get costs planning
     *
     * Returns the costs planning for a given year and organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/costs-planning',
            ...options
        });
    }
    /**
     * Update costs planning
     *
     * Updates the costs planning items for the given organization.
     */
    static update(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/costs-planning',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Import costs planning data
     *
     * Imports costs planning data from Google Sheets for the given organization.
     */
    static getImportData(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/costs-planning/import',
            ...options
        });
    }
}
export class CollaboratorCostsService {
    /**
     * Get collaborator costs list
     *
     * Returns a list of all collaborator costs and legal type
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs',
            ...options
        });
    }
    /**
     * Save collaborator costs
     *
     * Creates or updates a record of collaborator costs for a given month.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get collaborator cost history
     *
     * Returns a historical overview of cost development for a specific collaborator.
     */
    static getHistory(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs/{uuid}/history',
            ...options
        });
    }
    /**
     * Get average costs by position
     *
     * Returns an overview of average costs for individual job positions.
     */
    static getAverageCosts(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs/average',
            ...options
        });
    }
    /**
     * Get highest cost in given period
     *
     * Returns information about the highest hourly cost rate achieved in a specified time range.
     */
    static getHighestCostInMonths(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs/highest',
            ...options
        });
    }
    /**
     * Publish costs to PubSub
     *
     * Publishes the current state of collaborator costs to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator-costs/create-updated-messages',
            ...options
        });
    }
}
export class WorkTypeService {
    /**
     * Get all work types
     *
     * Returns a list of all available work types for the organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/work-types',
            ...options
        });
    }
    /**
     * Create new work type
     *
     * Creates a new category/type of work in the system.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/work-types',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete work type
     *
     * Removes a work type from the system by its UUID.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/work-types/{uuid}',
            ...options
        });
    }
    /**
     * Update existing work type
     *
     * Updates the name or properties of a work type by its UUID.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/work-types/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish work types to PubSub
     *
     * Publishes the current state of work types to Google Cloud PubSub.
     */
    static postCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/work-types/create-updated-messages',
            ...options
        });
    }
}
export class ProjectCalculationRevenueService {
    /**
     * Get project calculation revenues for a given month
     *
     * Returns a list of all revenues assigned to a project in a specific month.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/revenues/{month}',
            ...options
        });
    }
    /**
     * Create new project calculation revenue
     *
     * Adds a new revenue record to a project in a given month.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/revenues/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Copy project calculation revenues between months
     *
     * Copies all project revenues from one month to another.
     */
    static copy(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/revenues/copy/{fromMonth}/{toMonth}',
            ...options
        });
    }
    /**
     * Delete project calculation revenue
     *
     * Removes a revenue record from a project.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/revenues/{month}/{uuid}',
            ...options
        });
    }
    /**
     * Update project calculation revenue
     *
     * Updates details of a specific project revenue record.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/revenues/{month}/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorBillingService {
    /**
     * Get collaborator billings for a given month
     *
     * Returns a list of all collaborator billing records for a project in a specific month.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/collaborator-billings/{month}',
            ...options
        });
    }
    /**
     * Bulk upsert collaborator billings for a given month
     *
     * Replaces all collaborator billing records for a project in a specific month.
     */
    static bulkUpsert(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/collaborator-billings/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a collaborator billing record
     *
     * Soft-deletes a single collaborator billing record by ID.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/collaborator-billings/{id}',
            ...options
        });
    }
}
export class TicketTimeCorrectionService {
    /**
     * Get ticket time corrections
     *
     * Returns a list of all ticket time corrections (manual adjustments) based on filters.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/ticket-time-corrections',
            ...options
        });
    }
    /**
     * Create new ticket time correction
     *
     * Adds a new manual time correction to a ticket.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/ticket-time-corrections',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete ticket time correction
     *
     * Removes a manual ticket time correction.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/ticket-time-corrections/{uuid}',
            ...options
        });
    }
    /**
     * Update ticket time correction
     *
     * Updates an existing manual time correction for a ticket.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/ticket-time-corrections/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class WorkLogIssueService {
    /**
     * Get worklog issues
     *
     * Returns a list of all detected issues in worklogs (e.g., missing project, overtime).
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklog-issues',
            ...options
        });
    }
    /**
     * Get worklog issues statistics
     *
     * Returns summary statistics of worklog issues for given months.
     */
    static getStatistics(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklog-issues/statistics',
            ...options
        });
    }
    /**
     * Update worklog issue status
     *
     * Allows changing the status (e.g., resolved, ignored) of a specific worklog issue.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklog-issues/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get projects for issue filtering
     *
     * Returns a shortened list of projects for the purpose of filtering worklog issues.
     */
    static getProjects(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklog-issues/projects',
            ...options
        });
    }
    /**
     * Get collaborators for issue filtering
     *
     * Returns a shortened list of collaborators for the purpose of filtering worklog issues.
     */
    static getCollaborators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklog-issues/collaborators',
            ...options
        });
    }
}
export class WorkLogService {
    /**
     * Get collaborator worklogs
     *
     * Returns a list of all worklogs for a specific collaborator within a given time range.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/collaborator/{collaboratorUuid}/worklogs',
            ...options
        });
    }
    /**
     * Get collaborators for worklogs
     *
     * Returns a list of collaborators for whom the current user can view worklogs.
     */
    static getCollaborators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/worklogs/collaborators',
            ...options
        });
    }
}
export class ProjectCalculationTicketService {
    /**
     * Get ticket project assignments
     *
     * Returns per-ticket ERP project assignment data (forced and original project) for a date range. Used to enrich estimate-analysis data with ERP-side project overrides.
     */
    static getTicketProjectAssignments(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/tickets/project-assignments',
            ...options
        });
    }
    /**
     * Get project tickets for a date range
     *
     * Returns a list of project tickets for a specific date range and optionally for specific collaborators.
     */
    static getWorkLogsByProjectAndDateRange(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/tickets/date-range',
            ...options
        });
    }
    /**
     * Get project tickets for a given month
     *
     * Returns a list of all tickets assigned to a project in a specific month.
     */
    static getWorkLogsByProjectAndMonth(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/tickets/{month}',
            ...options
        });
    }
}
export class CompanyProfitService {
    /**
     * Get company profit for a given month
     *
     * Returns a summary overview of company profit, including revenues and costs for a specific month.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/company-profit',
            ...options
        });
    }
    /**
     * Update company profit note
     *
     * Saves or updates a text note for the company's financial results for a given month.
     */
    static putNote(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/company-profit/note/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get company profit analysis
     *
     * Returns a detailed financial analysis of company profit for a specified year.
     */
    static getAnalysis(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/company-profit/analysis',
            ...options
        });
    }
    /**
     * Update profit calculation configuration
     *
     * Updates settings for profit calculation (e.g., whether to include project profits or invoice revenues) for a given month.
     */
    static putConfig(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/company-profit/config/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CorrectionService {
    /**
     * Get financial corrections
     *
     * Returns a list of all manual financial corrections for a given month or bank transaction.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/correction',
            ...options
        });
    }
    /**
     * Create or update financial correction
     *
     * Saves a manual financial correction to the company profit.
     */
    static postCorrection(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/correction',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete financial correction
     *
     * Removes a manual financial correction from the system.
     */
    static deleteCorrection(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/correction/{uuid}',
            ...options
        });
    }
}
export class CollaboratorCostService {
    /**
     * Get collaborator costs for a project
     *
     * Returns a detailed breakdown of costs for individual collaborators assigned to a project in a specific month.
     */
    static getCollaboratorCostByProjectAndMonth(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/projects/{projectUuid}/collaborator-costs/{month}',
            ...options
        });
    }
}
export class MenuItemService {
    /**
     * Get all menu items
     *
     * Returns a hierarchical list of the main application menu items.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-items',
            ...options
        });
    }
    /**
     * Create new menu item
     *
     * Adds a new item to the main menu.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete menu item
     *
     * Removes a menu item from the system.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-items/{uuid}',
            ...options
        });
    }
    /**
     * Get menu item detail
     *
     * Returns the details of a specific menu item by its UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-items/{uuid}',
            ...options
        });
    }
    /**
     * Update menu item
     *
     * Updates the name, icon, or order of a menu item.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-items/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SubmenuItemService {
    /**
     * Get all submenu items
     *
     * Returns a list of all submenu items for the given organization.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/submenu-items',
            ...options
        });
    }
    /**
     * Create new submenu item
     *
     * Adds a new item to the submenu.
     */
    static post(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/submenu-items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete submenu item
     *
     * Removes a submenu item from the system.
     */
    static remove(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/submenu-items/{uuid}',
            ...options
        });
    }
    /**
     * Get submenu item detail
     *
     * Returns the details of a specific submenu item by its UUID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/submenu-items/{uuid}',
            ...options
        });
    }
    /**
     * Update submenu item
     *
     * Updates the name, path, or parent item of a submenu item.
     */
    static put(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/submenu-items/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class MenuItemBadgesService {
    /**
     * Get badges for menu items
     *
     * Returns counts of pending items for various modules (invoices, plans, etc.) to be displayed in the menu.
     */
    static get(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/menu-item-badges',
            ...options
        });
    }
}
export class HealthCheckService {
    /**
     * System health check
     *
     * Verifies the database connection status and other key system components.
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/health',
            ...options
        });
    }
}
export class EnumsService {
    /**
     * Get all enums
     *
     * Returns a list of all constants and enumerations used in the application (roles, currencies, contract types, etc.).
     */
    static getAll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/enums',
            ...options
        });
    }
}
export class TestSupportService {
    /**
     * Load test fixtures
     *
     * Resets the database and loads test fixtures from the fixtures directory.
     */
    static reset(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/erp/test-support/load-fixtures',
            ...options
        });
    }
}
